/**
 * Форма одноразового кода доступа покупателя после оплаты (`/handoff/:code`).
 *
 * ОДНО МЕСТО, ДВА ПОТРЕБИТЕЛЯ (правило двух концов, WEB-1844):
 *   · страница `PublicHandoffMagicLink` — решает, показывать ли покупателю
 *     «подтверждено» до ответа сервера (правдоподобный код) или сразу отказ;
 *   · очистка событий мониторинга `scrubPii` — МАСКИРУЕТ код в путях
 *     (`/handoff/K7QM4TZP` → `/handoff/:code`), потому что это
 *     предъявительский ключ к купленному доступу: сервер его погашает и выдаёт
 *     доступ, и лежать в журнале стороннего вендора он не должен (свежий
 *     взгляд пачки 43, проход 4).
 * Разойдись формы — страница считала бы кодом одно, а очистка прятала бы
 * другое; поэтому регулярка одна, а потребители её импортируют.
 *
 * Алфавит — base32 без похожих знаков (0/O, 1/I), длина 8 — как минтит
 * `backend/src/handoff/services/handoff-token.service.ts`.
 */
export const HANDOFF_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/** Целая строка — код. */
export const HANDOFF_CODE_SHAPE_RE = new RegExp(
  `^[${HANDOFF_CODE_ALPHABET}]{8}$`,
);

/** Сегмент пути `/handoff/<код>` в любом месте строки (адрес, имя транзакции, хлебная крошка). */
export const HANDOFF_CODE_PATH_RE = new RegExp(
  `(/handoff/)[${HANDOFF_CODE_ALPHABET}]{8}(?=$|[/?#\\s"'])`,
  'g',
);

export const HANDOFF_CODE_PATH_MASK = '$1:code';

/**
 * Вид кода для глаз покупателя — две четвёрки через дефис (`K7QM-29XT`), как в
 * эталоне `Handoff` (WEB-3826, сверка вида круг 2). ТОЛЬКО ПОКАЗ: в буфер
 * обмена, в адрес и на сервер уходит прежнее значение без дефиса. Не код
 * правильной формы — как есть.
 *
 * ПОКА НИКЕМ НЕ ЗОВЁТСЯ (вопрос оркестратору, отчёт WEB-3826-мелочи): сервер
 * намеренно не выбрасывает дефис из набранного кода (`normalizeHandoffCode`,
 * WEB-2481), и покупатель, перепечатавший код с экрана вместе с дефисом,
 * получил бы «код не найден». Включать — только вместе с решением про приём
 * дефиса на сервере.
 */
export function formatHandoffCodeForDisplay(code: string): string {
  return HANDOFF_CODE_SHAPE_RE.test(code)
    ? `${code.slice(0, 4)}-${code.slice(4)}`
    : code;
}
